"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactImageLightbox = _interopRequireDefault(require("react-image-lightbox"));
require("react-image-lightbox/style.css");
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));
require("react-perfect-scrollbar/dist/css/styles.css");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _ChatActions = require("../Chat/ChatActions");
var _config = require("../config");
var _ConversationItem = _interopRequireDefault(require("./ConversationItem"));
var _MessageLoading = _interopRequireDefault(require("./MessageLoading"));
var _CounterPropositionDialog = _interopRequireDefault(require("../Chat/dialogs/CounterPropositionDialog"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    avatarInConversation: {
      background: theme.palette.third.secondary,
      border: "1px #e5e5e5 solid",
      left: -32,
      bottom: 25,
      margin: 0,
      position: 'absolute',
      top: "20px"
    },
    avatar: {
      background: theme.palette.primary.main,
      border: '1px #e5e5e5 solid',
      left: -32,
      bottom: 25,
      margin: 0,
      position: 'absolute',
      padding: "10px"
    },
    bottom: _defineProperty({
      background: theme.palette.background.default,
      borderTop: '1px solid rgba(0, 0, 0, 0.13)'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem'
    }),
    bubble: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '100%',
      padding: 12,
      position: 'relative'
    },
    inputWrapper: {
      borderRadius: "8px",
      backgroundColor: theme.palette.third.third
    },
    message: {
      lineHeight: 1.2,
      whiteSpace: 'pre-wrap',
      minWidth: "60px",
      textAlign: "center"
    },
    messageRow: {
      maxWidth: '85vw',
      wordWrap: 'break-word',
      '&.contact': {
        '& $bubble': {
          '& $time': {
            marginLeft: 12
          },
          backgroundColor: theme.palette.grey[300],
          borderRadius: "8px",
          color: theme.palette.getContrastText(theme.palette.grey[300])
        },
        '&.first-of-group': {
          '& $bubble': {
            borderTopLeftRadius: 8
          }
        },
        '&.last-of-group': {
          '& $bubble': {
            borderBottomLeftRadius: 8
          }
        }
      },
      '&.contact + .me, &.me + .contact': {
        marginTop: 20,
        paddingTop: 20
      },
      '&.first-of-group': {
        '& $bubble': {
          borderTopLeftRadius: 8,
          paddingTop: 13
        }
      },
      '&.last-of-group': {
        '& $bubble': {
          '& $time': {
            display: 'flex'
          },
          borderBottomLeftRadius: 8,
          paddingBottom: 13
        }
      },
      '&.me': {
        paddingLeft: 40,
        '& $avatar': {
          margin: '0 0 0 16px',
          order: 2
        },
        '& $bubble': {
          '& $time': {
            justifyContent: 'flex-end',
            marginRight: 12,
            right: 0
          },
          backgroundColor: theme.palette.third.secondary,
          borderRadius: "8px",
          color: theme.palette.third.noContrastText,
          marginLeft: 'auto'
        },
        '&.first-of-group': {
          '& $bubble': {
            borderTopRightRadius: 8
          }
        },
        '&.last-of-group': {
          '& $bubble': {
            borderBottomRightRadius: 8
          }
        }
      },
      alignItems: 'flex-start',
      display: 'flex',
      flex: '0 0 auto',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: '0 16px 4px 16px',
      position: 'relative'
    },
    time: {
      fontSize: 11,
      left: 0,
      marginTop: 0,
      position: 'absolute',
      top: '100%',
      whiteSpace: 'nowrap',
      width: '100%'
    },
    loader: {
      fill: "".concat(theme.palette.primary.main, " !important")
    },
    IconButton: {
      backgroundColor: theme.palette.third.main,
      padding: "25px",
      borderRadius: "8px",
      height: 40,
      color: "black",
      marginLeft: "15px",
      '&:hover': {
        opacity: "0.5"
      }
    },
    messagesColor: {
      backgroundColor: theme.palette.third.main
    },
    handlePropositionColor: {
      backgroundColor: theme.palette.third.main,
      '&:hover': {
        backgroundColor: theme.palette.third.secondary
      }
    },
    messageTextInput: _defineProperty({}, theme.breakpoints.down('sm'), {
      height: 0,
      marginLeft: 10,
      marginRight: 0
    })
  };
});
var defaultConversationItem = _ConversationItem.default;
function Conversation(props) {
  var intl = props.intl;
  var ConversationItem = props.conversationItem || defaultConversationItem;
  var fileInput = /*#__PURE__*/_react.default.createRef();
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    chatScroll = _useState2[0],
    handleChatScroll = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    imagePreview = _useState4[0],
    handleImagePreview = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    messageText = _useState6[0],
    handleMessageText = _useState6[1];
  var _useState7 = (0, _react.useState)({
      counterPropositionToHandle: null,
      imagePreview: null,
      isAcceptCounterPropositionDialogOpen: false,
      isRefusedCounterPropositionDialogOpen: false,
      messageText: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    state = _useState8[0],
    setState = _useState8[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var chatReducer = _ref.chatReducer,
        auth = _ref.auth;
      return {
        contacts: chatReducer.contacts,
        chat: chatReducer.chat,
        chatPagination: chatReducer.chatPagination,
        sendMessageInProgress: chatReducer.sendMessageInProgress,
        getChatInProgress: chatReducer.getChatInProgress,
        selectedContactId: chatReducer.selectedContactId,
        user: auth.user
      };
    }),
    contacts = _useSelector.contacts,
    chat = _useSelector.chat,
    chatPagination = _useSelector.chatPagination,
    sendMessageInProgress = _useSelector.sendMessageInProgress,
    getChatInProgress = _useSelector.getChatInProgress,
    selectedContactId = _useSelector.selectedContactId,
    user = _useSelector.user;
  (0, _react.useEffect)(function () {
    if (props.match.params.id) {
      // clean all chat data and it pagination before get it first time
      dispatch({
        type: _ChatActions.CLEAN_CHAT
      });
      // get chat using pagination
      dispatch({
        type: _ChatActions.GET_CHAT_START,
        contactId: props.match.params.id,
        params: {
          'conversation.id': props.match.params.id,
          _embed: ['user', 'proposition', 'attachments'],
          _sort: '-created_at',
          _page: 1,
          _per_page: _config.CHAT_PER_PAGE
        },
        onSuccess: function onSuccess() {
          return scrollToBottom();
        }
      });
    }
  }, [props.match.params.id]);
  (0, _react.useEffect)(function () {
    if ((chatPagination === null || chatPagination === void 0 ? void 0 : chatPagination.page) === 1) {
      scrollToBottom();
    }
  }, [chat]);
  var shouldShowContactAvatar = function shouldShowContactAvatar(item, i) {
    var _user$id;
    return item.user.id.toString() !== (user === null || user === void 0 ? void 0 : (_user$id = user.id) === null || _user$id === void 0 ? void 0 : _user$id.toString()) && (chat[i + 1] && chat[i + 1].type !== 'receive' || !chat[i + 1]);
  };
  var isFirstMessageOfGroup = function isFirstMessageOfGroup(item, i) {
    return i === 0 || chat[i - 1] && chat[i - 1].user.id.toString() !== item.user.id.toString();
  };
  var isLastMessageOfGroup = function isLastMessageOfGroup(item, i) {
    return i === chat.length - 1 || chat[i + 1] && chat[i + 1].user.id.toString() !== item.user.id.toString();
  };
  var onInputChange = function onInputChange(event) {
    handleMessageText(event.target.value);
  };
  var sendMessage = function sendMessage(message, attachment, conversation) {
    dispatch({
      attachment: attachment,
      conversation: conversation,
      message: message,
      type: _ChatActions.SEND_MESSAGE_START
    });
  };
  var isContainsPhoneNumber = function isContainsPhoneNumber(phoneNumber) {
    var regex = new RegExp(/^(\w*\s*)*[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}?(\s*\w*)*$/);
    return regex.test(phoneNumber);
  };
  var onMessageSubmit = function onMessageSubmit(event) {
    event.preventDefault();
    if (messageText === '') {
      return;
    }
    if (_config.MASK_PHONE_NUMBER_IN_CHAT && isContainsPhoneNumber(messageText)) {
      var maskPhoneNumber = messageText.replace(/[0-9]/g, '*');
      sendMessage(maskPhoneNumber, null, "".concat(selectedContactId));
    } else {
      sendMessage(messageText, null, "".concat(selectedContactId));
    }
    handleMessageText('');
    scrollToBottom();
  };
  var scrollToBottom = function scrollToBottom() {
    if (chatScroll) {
      chatScroll.scrollTop = chatScroll.scrollHeight;
    }
  };
  var handleAddImageClick = function handleAddImageClick(e) {
    fileInput.current.click();
  };
  var handleAddImageChange = function handleAddImageChange(e) {
    e.preventDefault();
    var files = e.target.files;
    sendMessage(' ', files, "".concat(selectedContactId));
  };
  var handleImagePreviewOpen = function handleImagePreviewOpen(item) {
    handleImagePreview("".concat(_config.BASE_URL ? _config.BASE_URL.slice(0, -1) : null).concat(item.url));
  };
  var handleImagePreviewClose = function handleImagePreviewClose() {
    handleImagePreview(null);
  };
  var handleAddProductToShoppingCart = function handleAddProductToShoppingCart() {
    var contact = _lodash.default.find(contacts, function (item) {
      return item.id === selectedContactId;
    });
    localStorage.setItem('cart', JSON.stringify({
      uuid: contact.product.uuid
    }));
    //add to cart here
    dispatch({
      type: _ChatActions.ADD_TO_CART_AFTER_PROPOSITION,
      product: {
        uuid: contact.product.uuid
      },
      onSuccess: function onSuccess() {
        dispatch({
          history: props.history,
          to: '/cart',
          type: 'REDIRECT'
        });
      }
    });
  };
  var fetchMoreMessages = function fetchMoreMessages() {
    if (!getChatInProgress) {
      var count = chatPagination.count,
        page = chatPagination.page;
      var hasMore = count > chat.length;
      if (hasMore) {
        dispatch({
          type: _ChatActions.GET_CHAT_START,
          contactId: props.match.params.id,
          params: {
            'conversation.id': props.match.params.id,
            _embed: ['user', 'proposition', 'attachments'],
            _sort: '-created_at',
            _page: page + 1,
            _per_page: _config.CHAT_PER_PAGE
          },
          onSuccess: function onSuccess() {
            if (chatScroll) {
              chatScroll.scrollTop = 500;
            }
          }
        });
      }
    }
  };
  var handleAcceptCounterPropositionDeleteDialogClose = function handleAcceptCounterPropositionDeleteDialogClose(result) {
    if (result && state.counterPropositionToHandle !== null) {
      dispatch({
        handleType: 'accepted',
        itemId: state.counterPropositionToHandle.id,
        type: _ChatActions.UPDATE_COUTER_PROPOSITION_START
      });
    }
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isAcceptCounterPropositionDialogOpen: false,
      counterPropositionToHandle: null
    }));
  };
  var handleRefusedCounterPropositionDeleteDialogClose = function handleRefusedCounterPropositionDeleteDialogClose(result) {
    if (result && state.counterPropositionToHandle !== null) {
      dispatch({
        handleType: 'refused',
        itemId: state.counterPropositionToHandle.id,
        type: _ChatActions.UPDATE_COUTER_PROPOSITION_START
      });
    }
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isRefusedCounterPropositionDialogOpen: false,
      counterPropositionToHandle: null
    }));
  };
  var handleCounterPropositionOpen = function handleCounterPropositionOpen(item, type) {
    if (type === 'accept') {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isRefusedCounterPropositionDialogOpen: false,
        isAcceptCounterPropositionDialogOpen: true,
        counterPropositionToHandle: item
      }));
    } else {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isAcceptCounterPropositionDialogOpen: false,
        isRefusedCounterPropositionDialogOpen: true,
        counterPropositionToHandle: item
      }));
    }
  };
  var chatContent;
  if (chat && chat.length > 0) {
    chatContent = chat.filter(function (obj, index, arr) {
      return arr.map(function (mapObj) {
        return mapObj.id;
      }).indexOf(obj.id) === index;
    });
  } else {
    chatContent = chat;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("flex flex-col", 'flex flex-1 z-10')
  }, /*#__PURE__*/_react.default.createElement(_reactPerfectScrollbar.default, {
    onScrollY: function onScrollY(container) {
      return container.scrollTop === 0 && fetchMoreMessages();
    },
    containerRef: function containerRef(ref) {
      return handleChatScroll(ref);
    },
    className: "flex flex-1 flex-col px-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col py-4 pr-0",
    style: {
      marginLeft: 36
    }
  }), chatContent && chatContent.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col py-4 pr-0",
    style: {
      marginLeft: 36
    }
  }, getChatInProgress && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: 'bars',
    className: classes.loader,
    height: '15%'
  })), chatContent.map(function (item, i) {
    var _chatContent, _chatContent$user, _chatContent2;
    return /*#__PURE__*/_react.default.createElement(ConversationItem, {
      key: i,
      item: item,
      classes: classes,
      isFirstMessageOfGroup: isFirstMessageOfGroup(item, i),
      isLastMessageOfGroup: isLastMessageOfGroup(item, i),
      shouldShowContactAvatar: shouldShowContactAvatar(item, i),
      onImagePreview: handleImagePreviewOpen,
      shouldShowSendingTime: !(!_lodash.default.isEmpty(chatContent[i + 1]) && ((_chatContent = chatContent[i + 1]) === null || _chatContent === void 0 ? void 0 : (_chatContent$user = _chatContent.user) === null || _chatContent$user === void 0 ? void 0 : _chatContent$user.id) === item.user.id && new Date((_chatContent2 = chatContent[i + 1]) === null || _chatContent2 === void 0 ? void 0 : _chatContent2.created_at) - new Date(item.created_at) < 60000),
      onPurchaseProduct: handleAddProductToShoppingCart,
      user: user,
      onCounterPropositionHandle: handleCounterPropositionOpen
    });
  }), sendMessageInProgress && /*#__PURE__*/_react.default.createElement(_MessageLoading.default, {
    classes: classes
  })), !getChatInProgress && chat && chat.length === 0 && selectedContactId && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1 items-center justify-center"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-128",
    color: "disabled",
    style: {
      fontSize: 128
    }
  }, "chat")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "px-16 pb-24 text-center",
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Start a conversation by typing your message below",
    defaultMessage: "Start a conversation by typing your message below"
  }))), !getChatInProgress && chat && !selectedContactId && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1 items-center justify-center"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-128",
    color: "disabled",
    style: {
      fontSize: 128
    }
  }, "chat")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "px-16 pb-24 text-center",
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Select a contact to start a conversation",
    defaultMessage: "Select a contact to start a conversation"
  }))), getChatInProgress && chat.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1 items-center justify-center"
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: 'bars',
    className: classes.loader,
    height: 45,
    width: 45
  })))), chat && selectedContactId && /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onMessageSubmit,
    className: (0, _classnames.default)("py-4 px-4", classes.bottom)
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleAddImageClick
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-28",
    color: "action"
  }, "insert_photo")), /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    ref: fileInput,
    accept: "image/bmp,image/gif,image/jpeg,image/png,image/x-ms-bmp",
    multiple: true,
    style: {
      display: 'none'
    },
    onChange: handleAddImageChange
  }), /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: (0, _classnames.default)(classes.inputWrapper, "flex items-center relative"),
    style: {
      marginLeft: 5,
      width: '100%'
    },
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    autoFocus: false,
    id: "message-inpute",
    className: "flex-1",
    InputProps: {
      classes: {
        input: "",
        root: (0, _classnames.default)('flex flex-grow flex-no-shrink ml-8 mr-16 my-4', classes.messageTextInput)
      },
      disableUnderline: true,
      placeholder: intl.formatMessage({
        id: "Tapez votre message ici",
        defaultMessage: "Tapez votre message ici"
      })
    },
    InputLabelProps: {
      className: classes.bootstrapFormLabel,
      shrink: false
    },
    onChange: onInputChange,
    value: messageText,
    multiline: true
  }), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: "absolute pin-r pin-t",
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-24",
    color: "action"
  }, "send"))))), !!imagePreview && /*#__PURE__*/_react.default.createElement(_reactImageLightbox.default, {
    mainSrc: imagePreview,
    onCloseRequest: handleImagePreviewClose
  }), /*#__PURE__*/_react.default.createElement(_CounterPropositionDialog.default, {
    isOpen: state.isAcceptCounterPropositionDialogOpen,
    onClose: handleAcceptCounterPropositionDeleteDialogClose,
    type: 'accept',
    setState: setState
  }), /*#__PURE__*/_react.default.createElement(_CounterPropositionDialog.default, {
    isOpen: state.isRefusedCounterPropositionDialogOpen,
    onClose: handleRefusedCounterPropositionDeleteDialogClose,
    type: 'refused',
    setState: setState
  }));
}
var _default = (0, _reactRouter.withRouter)((0, _Translations.injectIntl)(Conversation));
exports.default = _default;